<template>
  <div :style="'color: ' + getColor(type, status)">{{ getText(type, status) }}</div>
</template>
<script>
export default {
  name: 'TextStatus',
  props: {
    status: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      enum: ['delivery', 'order', 'audit'],
      default: ''
    }
  },
  methods: {
    click() {
      this.$emit('click')
    },
    getColor(type, status) {
      if (type === 'order') {
        switch (status) {
          case 'approved':
          case 'supplierSent':
            return '#32a852'
          case 'created':
            return '#fcba03'
          case 'notApproved':
            return '#eb4034'
          default:
            return ''
        }
      }
      if (type === 'delivery') {
        switch (status) {
          case 'noSchedule':
          case 'incompleteDelivery':
            return '#eb4034'
          case 'delivering':
            return '#fcba03'
          case 'completeDelivery':
            return '#32a852'
          case 'toInventory':
            return '#3461eb'
          default:
            return ''
        }
      }
      if (type === 'audit') {
        switch (status) {
          case 'noSchedule':
          case 'incompleteDelivery':
            return '#eb4034'
          case 'delivering':
            return '#fcba03'
          case 'noCompleteDelivery':
            return '#eb4034'
          case 'completeDelivery':
            return '#32a852'
          case 'toInventory':
            return '#3461eb'
          default:
            return ''
        }
      }
    },
    getText(type, status) {
      if (type === 'order') {
        switch (status) {
          case 'created':
            return 'Đang tạo'
          case 'notApproved':
            return 'Chờ duyệt'
          case 'approved':
            return 'Đã duyệt'
          case 'supplierSent':
            return 'Đã gửi hãng'
          default:
            return ''
        }
      }
      if (type === 'delivery') {
        switch (status) {
          case 'noSchedule':
            return 'Chưa có lịch'
          case 'delivering':
            return 'Đang giao'
          case 'incompleteDelivery':
            return 'Chưa giao đủ'
          case 'completeDelivery':
            return 'Đã giao đủ'
          case 'toInventory':
            return 'Gửi kho hãng'
          default:
            return ''
        }
      }
      if (type === 'audit') {
        switch (status) {
          case 'delivering':
            return 'Đang giao'
          case 'incompleteDelivery':
            return 'Chưa giao đủ'
          case 'completeDelivery':
            return 'Đã giao đủ'
          default:
            return ''
        }
      }
    }
  }
}
</script>
